<template>
  <div>
    <Input
      @on-focus="openGroup = true"
      :value="name"
      readonly
      placeholder="请选择"
      :disabled='disabled'
    ></Input>

    <Drawer
      :placement="placement"
      :closable="false"
      v-model="openGroup"
      width='450'
      draggable
      class="my-drawer"
    >
      <person-tool @person="rePerson" :filterGroup="filterGroup"></person-tool>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["name","placement","filterGroup","disabled"],
  data() {
    return {
      openGroup: false,
    };
  },
  methods: {
    rePerson(v) {
      this.openGroup = false;
      this.$emit("update:id", v.id);
      this.$emit("update:name", v.name);
      this.$emit("update:deviceNo", v.deviceNo);
      this.$emit("person", v);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/selectPerson.vue